(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1042],{

/***/ 68019:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E": function() { return /* binding */ Img; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(68777);
/* harmony import */ var react_lazy_load_image_component_src_effects_blur_css__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(68893);
/* harmony import */ var react_lazy_load_image_component_src_effects_blur_css__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react_lazy_load_image_component_src_effects_blur_css__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85893);





var Img = function Img(_ref) {
  var nolazy = _ref.nolazy,
      visible = _ref.visible,
      srcSm = _ref.srcSm,
      src = _ref.src,
      position = _ref.position,
      objectFit = _ref.objectFit,
      height = _ref.height,
      width = _ref.width,
      banner = _ref.banner,
      alt = _ref.alt,
      left = _ref.left,
      margin = _ref.margin,
      right = _ref.right,
      top = _ref.top,
      bottom = _ref.bottom;
  var DefaultBanner = '/images/static/blurbg.svg';

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(0),
      deviceWidth = _useState[0],
      setDeviceWidth = _useState[1]; // set device width


  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    function HandleWidth() {
      setDeviceWidth(window.innerWidth);
    }

    window.addEventListener('resize', HandleWidth);
    HandleWidth();
    return function () {
      window.removeEventListener('resize', HandleWidth);
    };
  });
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(StyledImg, {
    className: "global-image",
    srcSm: srcSm,
    objectFit: objectFit,
    margin: margin,
    position: position,
    left: left,
    right: right,
    top: top,
    bottom: bottom,
    height: height,
    width: width,
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
      quality: 100,
      priority: true,
      blurDataURL: "".concat(DefaultBanner),
      alt: alt || 'Shanta Securities Limited',
      objectFit: 'cover',
      layout: 'fill',
      src: src ? deviceWidth > 600 ? src : srcSm ? srcSm : src : DefaultBanner // use normal <img> attributes as props

    })
  });
};
var StyledImg = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "Img__StyledImg",
  componentId: "sc-1091rec-0"
})(["position:", ";height:", ";width:", ";top:", ";left:", ";bottom:", ";right:", ";margin:", ";img{width:100%;height:100%;object-fit:", ";position:absolute;top:0;left:0;right:0;bottom:0;}"], function (props) {
  return props.position || 'absolute';
}, function (props) {
  return props.height || '100%';
}, function (props) {
  return props.width || '100%';
}, function (props) {
  return props.top || 0;
}, function (props) {
  return props.left || 0;
}, function (props) {
  return props.bottom || 0;
}, function (props) {
  return props.right || 0;
}, function (props) {
  return props.margin || 0;
}, function (props) {
  return props.objectFit || 'cover';
});

/***/ }),

/***/ 81875:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(68777);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(10682);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(21608);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(31555);
/* harmony import */ var react_icons_bs__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(63750);
/* harmony import */ var swiper_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(22546);
/* harmony import */ var swiper__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(50067);
/* harmony import */ var swiper_css__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(30933);
/* harmony import */ var swiper_css__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(swiper_css__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var swiper_css_navigation__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(92);
/* harmony import */ var swiper_css_navigation__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(swiper_css_navigation__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var swiper_css_pagination__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(68770);
/* harmony import */ var swiper_css_pagination__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(swiper_css_pagination__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var swiper_css_scrollbar__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(13390);
/* harmony import */ var swiper_css_scrollbar__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(swiper_css_scrollbar__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _Img__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(68019);
/* harmony import */ var _styles_globalStyleVars__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(68312);
/* harmony import */ var react_html_parser__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(30653);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(85893);

















var RandomSliderV1 = function RandomSliderV1(_ref) {
  var Data = _ref.Data,
      desc = _ref.desc;
  // SwiperCore.use([Autoplay]);
  var leftRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)();
  var rightRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)();
  var mLeftRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)();
  var mRightRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)();
  var containerRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)();
  var sliderRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)();

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(90),
      offset = _useState[0],
      setOffset = _useState[1];

  var _useState2 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(0),
      theWidth = _useState2[0],
      SetTheWidth = _useState2[1];

  var _useState3 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(1),
      activeNumber = _useState3[0],
      setActiveNumber = _useState3[1];

  var _useState4 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(1),
      totalNumber = _useState4[0],
      setTotalNumber = _useState4[1];

  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    mLeftRef.current.addEventListener('click', function () {
      if (document.querySelector('.swiper-button-prev')) {
        document.querySelector('.swiper-button-prev').click();
      }
    });
    mRightRef.current.addEventListener('click', function () {
      if (document.querySelector('.swiper-button-next')) {
        document.querySelector('.swiper-button-next').click();
      }
    });
    setOffset(document.querySelector(' .container').offsetLeft);
  }, [Data]);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    var _containerRef$current, _document$querySelect, _document$querySelect2;

    setOffset((_containerRef$current = containerRef.current) === null || _containerRef$current === void 0 ? void 0 : _containerRef$current.offsetLeft);
    window.addEventListener('resize', function () {
      var _containerRef$current2;

      setOffset((_containerRef$current2 = containerRef.current) === null || _containerRef$current2 === void 0 ? void 0 : _containerRef$current2.offsetLeft);
      SetTheWidth(window.innerWidth);
    }); // slider number

    var getActiveItem = (_document$querySelect = document.querySelector('.swiper-pagination-current')) === null || _document$querySelect === void 0 ? void 0 : _document$querySelect.innerHTML;
    var getTotalItem = (_document$querySelect2 = document.querySelector('.swiper-pagination-total')) === null || _document$querySelect2 === void 0 ? void 0 : _document$querySelect2.innerHTML;
    setActiveNumber(getActiveItem);
    setTotalNumber(getTotalItem);
  }, [Data]);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    if (sliderRef.current) {
      var swiperInstance = sliderRef.current.swiper;

      if (swiperInstance) {
        setTotalNumber(swiperInstance.slides.length);
      }
    }
  }, [Data]);

  var _useState5 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(0),
      swiperIndex = _useState5[0],
      setSwiperIndex = _useState5[1]; // const handleSlideChange = (swiper) => {
  //     setSwiperIndex(swiper.realIndex);
  // };


  var location = (0,next_router__WEBPACK_IMPORTED_MODULE_9__.useRouter)();
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useLayoutEffect)(function () {
    var adjustBlogSlider = function adjustBlogSlider() {
      var blogSlider = document.querySelector('.blog-slider');
      var blogSingleInner = document.querySelector('.blog-single__inner');

      if (blogSlider && blogSingleInner) {
        var heightBlog = blogSlider.clientHeight;
        var heightBlogSingle = blogSingleInner.clientHeight;
        var total = heightBlog - heightBlogSingle;
        var totalHeight = heightBlog + total;
        totalHeight = totalHeight ? totalHeight : 760;
        blogSlider.style.transform = 'translateY(' + -totalHeight / 2 + 'px)';
        blogSlider.style.marginBottom = -totalHeight / 2 + 'px';
      }
    }; // Call the function on component mount


    adjustBlogSlider();
  }, [location === null || location === void 0 ? void 0 : location.pathname, Data]); // Empty dependency array ensures the effect runs only once

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)(StyledBlog, {
    offset: offset,
    className: "blog-slider ",
    children: [Data && (Data === null || Data === void 0 ? void 0 : Data.length) > 0 ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
      className: '',
      ref: containerRef,
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)(react_bootstrap__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
          md: 5,
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("div", {
            className: "blog-button",
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("div", {
              className: "slider-nav",
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)("ul", {
                children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("li", {
                  className: "hover",
                  id: 'service-prev',
                  children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(react_icons_bs__WEBPACK_IMPORTED_MODULE_14__/* .BsChevronLeft */ .pjk, {})
                }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("li", {
                  className: "hover",
                  id: 'service-next',
                  children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(react_icons_bs__WEBPACK_IMPORTED_MODULE_14__/* .BsChevronRight */ .fmn, {})
                })]
              })
            })
          })
        }), desc && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
          md: {
            span: 7
          },
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("div", {
            className: 'short-desc',
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("p", {
              className: "split-up",
              children: desc
            })
          })
        })]
      })
    }) : '', /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)("div", {
      className: " fade-up blog-slider__slider-wrap",
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("div", {
        className: "blog-slider__slider-wrap__inner",
        children: Data && (Data === null || Data === void 0 ? void 0 : Data.length) > 0 && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(swiper_react__WEBPACK_IMPORTED_MODULE_1__/* .Swiper */ .tq, {
          loop: true,
          slidesPerView: 1 //     autoplay= {{
          //     delay: 1500, // specify the autoplay delay here if you want to use it separately from the 'speed' prop
          //     disableOnInteraction: true, // Autoplay will not be stopped when the user interacts with the Swiper
          //
          // }}
          ,
          autoplay: false,
          lazy: true,
          spaceBetween: 30,
          speed: "1500",
          modules: [swiper__WEBPACK_IMPORTED_MODULE_2__/* .Autoplay */ .pt, swiper__WEBPACK_IMPORTED_MODULE_2__/* .Pagination */ .tl, swiper__WEBPACK_IMPORTED_MODULE_2__/* .Navigation */ .W_, swiper__WEBPACK_IMPORTED_MODULE_2__/* .Mousewheel */ .Gk],
          navigation: {
            prevEl: '#service-prev',
            nextEl: '#service-next'
          } // onSlideChange={handleSlideChange}
          ,
          breakpoints: {
            320: {
              slidesPerView: 1,
              spaceBetween: 30
            },
            768: {
              slidesPerView: 2,
              spaceBetween: 30
            },
            1024: {
              slidesPerView: 2,
              spaceBetween: 30
            }
          },
          ref: sliderRef,
          className: "mySwiper",
          children: Data === null || Data === void 0 ? void 0 : Data.map(function (e, index) {
            var _e$images, _e$images$, _e$images2, _e$images2$, _e$data, _e$data2;

            return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(swiper_react__WEBPACK_IMPORTED_MODULE_1__/* .SwiperSlide */ .o5, {
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("div", {
                className: "blog-single ",
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)("div", {
                  className: "blog-single__inner",
                  children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("div", {
                    className: "image-wrapper",
                    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(_Img__WEBPACK_IMPORTED_MODULE_7__/* .Img */ .E, {
                      alt: 'Shanta Securities Limited',
                      src: e !== null && e !== void 0 && (_e$images = e.images) !== null && _e$images !== void 0 && (_e$images$ = _e$images[0]) !== null && _e$images$ !== void 0 && _e$images$.full_path ? e === null || e === void 0 ? void 0 : (_e$images2 = e.images) === null || _e$images2 === void 0 ? void 0 : (_e$images2$ = _e$images2[0]) === null || _e$images2$ === void 0 ? void 0 : _e$images2$.full_path : 'images/static/blur.jpg',
                      objectFit: 'cover',
                      layout: 'fill'
                    })
                  }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("div", {
                    className: "blog-single__inner__content",
                    "data-index": index + 1,
                    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)("div", {
                      className: "blog-single__inner__content__top",
                      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("h2", {
                        className: '',
                        children: e === null || e === void 0 ? void 0 : (_e$data = e.data) === null || _e$data === void 0 ? void 0 : _e$data.title
                      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("div", {
                        children: (0,react_html_parser__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .ZP)(e === null || e === void 0 ? void 0 : (_e$data2 = e.data) === null || _e$data2 === void 0 ? void 0 : _e$data2.description)
                      })]
                    })
                  })]
                })
              }, index)
            }, index);
          })
        })
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("div", {
        className: "slider-nav-mobile",
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsxs)("ul", {
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("li", {
            className: "hover",
            ref: mLeftRef,
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(react_icons_bs__WEBPACK_IMPORTED_MODULE_14__/* .BsChevronLeft */ .pjk, {})
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)("li", {
            className: "hover",
            ref: mRightRef,
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__.jsx)(react_icons_bs__WEBPACK_IMPORTED_MODULE_14__/* .BsChevronRight */ .fmn, {})
          })]
        })
      })]
    })]
  });
};

var StyledBlog = styled_components__WEBPACK_IMPORTED_MODULE_15__/* ["default"].section.withConfig */ .ZP.section.withConfig({
  displayName: "RandomSliderServices__StyledBlog",
  componentId: "sc-1snd42d-0"
})([".swiper-button-disabled{opacity:0.5 !important;}.short-desc{font-size:28px;font-weight:300;line-height:36px;color:#3C3C3B;margin-bottom:75px;p{font-size:28px;font-weight:300;line-height:36px;color:#3C3C3B;}}.image-wrapper{position:absolute;left:0;right:0;bottom:0;height:50%;}.blog-button{display:flex;justify-content:space-between;align-items:center;.slider-nav{ul{display:flex;}li{height:40px;width:40px;background-color:black;display:flex;align-items:center;justify-content:center;border-radius:50%;cursor:pointer;&:nth-of-type(1){margin-right:20px;}svg{color:#ffffff;z-index:2;}}}}.swiper-button-next,.swiper-button-prev{position:absolute;height:40px;width:40px;top:0;bottom:0;margin:auto;z-index:99;background-color:red;}.swiper-button-next,.swiper-button-prev,.swiper-pagination{opacity:0;visibility:hidden;}.swiper-initialized{margin-left:", "px;padding-right:25%;}.slider-nav-mobile{display:none;}.blog-slider{&__slider-wrap{&__inner{.blog-single{&__inner{}}}}}.blog-single__inner{padding-top:calc(470 / 470 * 100%);position:relative;a{position:absolute;height:100%;width:100%;left:0;top:0;z-index:3;}&__content{position:absolute;top:0;height:50%;right:0;left:0;transition:1s all cubic-bezier(.25,.74,.22,.99);&:after{content:'';height:100%;width:100%;background-color:#3C3C3B;top:0;left:0;right:0;position:absolute;transition:1s all cubic-bezier(.25,.74,.22,.99);}&:before{content:attr(data-index);position:absolute;z-index:99;left:35px;color:#C6C6C6;font-size:136px;line-height:136px;bottom:-75px;font-family:'Avenir Book';transition:1s all cubic-bezier(.25,.74,.22,.99);}&__top{p{font-size:20px;font-weight:300;color:#FFFFFF;line-height:28px;top:120px;position:absolute;left:40px;z-index:2;right:40px;margin:0;transform:translateY(100%);opacity:0;transition:all 1s cubic-bezier(.25,.74,.22,.99);overflow:hidden;display:-webkit-box;-webkit-line-clamp:5;-webkit-box-orient:vertical;}h2{position:absolute;top:40px;left:40px;right:40px;z-index:2;font-size:40px;font-weight:bold;line-height:52px;font-family:'Avenir Heavy';letter-spacing:-1px;color:#FFFFFF;margin:0;transition:all 1s cubic-bezier(.25,.74,.22,.99);overflow:hidden;display:-webkit-box;-webkit-line-clamp:5;-webkit-box-orient:vertical;}}&__bottom{position:absolute;margin:0;left:40px;right:40px;bottom:24px;display:flex;justify-content:space-between;border-top:1px solid #221F1F;padding-top:20px;z-index:2;h4{font-size:60px;font-weight:600;color:", ";line-height:60px;transition:color 1s cubic-bezier(.25,.74,.22,.99);}p{font-size:12px;color:", ";text-align:right;font-weight:600;line-height:18px;transition:color 1s cubic-bezier(.25,.74,.22,.99);span{display:block;color:", ";}}}}&:hover{.blog-single__inner__content:after{height:100%;}.blog-single__inner__content:before{transform:translateY(80%);opacity:0;}.blog-single__inner__content{height:100%;}.blog-single__inner__content__top{h2{}p{transform:none;opacity:1;}}.blog-single__inner__content__bottom{border-color:#FFF;h4{color:#ffffff;}p{color:#ffffff;span{color:#ffffff;}}}}}@media (max-width:992px) and (min-width:768px){.blog-single__inner__content::before{font-size:100px;line-height:122px;bottom:-66px;}}@media (max-width:767px){.swiper-initialized{margin-left:0;padding-right:0;}.blog-slider{&__slider-wrap{margin-left:15px;margin-right:15px;.slider-nav-mobile{margin-top:40px;ul{display:flex;}li{height:50px;width:50px;background-color:#000;display:flex;align-items:center;justify-content:center;border-radius:50%;cursor:pointer;&:nth-of-type(1){margin-right:20px;}svg{color:#ffffff;z-index:2;}}}}}.blog-button{margin-bottom:40px;.slider-nav{}}.slider-nav-mobile{}}"], function (props) {
  return props.offset + 15;
}, _styles_globalStyleVars__WEBPACK_IMPORTED_MODULE_16__/* .hover */ .Mr, _styles_globalStyleVars__WEBPACK_IMPORTED_MODULE_16__/* .hover */ .Mr, _styles_globalStyleVars__WEBPACK_IMPORTED_MODULE_16__/* .hover */ .Mr);
/* harmony default export */ __webpack_exports__["default"] = (/*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.memo(RandomSliderV1));

/***/ }),

/***/ 92:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 13390:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 88357:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "w_": function() { return /* reexport */ GenIcon; }
});

// UNUSED EXPORTS: DefaultContext, IconBase, IconContext, IconsManifest

;// CONCATENATED MODULE: ./node_modules/react-icons/lib/esm/iconsManifest.js
var IconsManifest = [
  {
    "id": "ci",
    "name": "Circum Icons",
    "projectUrl": "https://circumicons.com/",
    "license": "MPL-2.0 license",
    "licenseUrl": "https://github.com/Klarr-Agency/Circum-Icons/blob/main/LICENSE"
  },
  {
    "id": "fa",
    "name": "Font Awesome 5",
    "projectUrl": "https://fontawesome.com/",
    "license": "CC BY 4.0 License",
    "licenseUrl": "https://creativecommons.org/licenses/by/4.0/"
  },
  {
    "id": "fa6",
    "name": "Font Awesome 6",
    "projectUrl": "https://fontawesome.com/",
    "license": "CC BY 4.0 License",
    "licenseUrl": "https://creativecommons.org/licenses/by/4.0/"
  },
  {
    "id": "io",
    "name": "Ionicons 4",
    "projectUrl": "https://ionicons.com/",
    "license": "MIT",
    "licenseUrl": "https://github.com/ionic-team/ionicons/blob/master/LICENSE"
  },
  {
    "id": "io5",
    "name": "Ionicons 5",
    "projectUrl": "https://ionicons.com/",
    "license": "MIT",
    "licenseUrl": "https://github.com/ionic-team/ionicons/blob/master/LICENSE"
  },
  {
    "id": "md",
    "name": "Material Design icons",
    "projectUrl": "http://google.github.io/material-design-icons/",
    "license": "Apache License Version 2.0",
    "licenseUrl": "https://github.com/google/material-design-icons/blob/master/LICENSE"
  },
  {
    "id": "ti",
    "name": "Typicons",
    "projectUrl": "http://s-ings.com/typicons/",
    "license": "CC BY-SA 3.0",
    "licenseUrl": "https://creativecommons.org/licenses/by-sa/3.0/"
  },
  {
    "id": "go",
    "name": "Github Octicons icons",
    "projectUrl": "https://octicons.github.com/",
    "license": "MIT",
    "licenseUrl": "https://github.com/primer/octicons/blob/master/LICENSE"
  },
  {
    "id": "fi",
    "name": "Feather",
    "projectUrl": "https://feathericons.com/",
    "license": "MIT",
    "licenseUrl": "https://github.com/feathericons/feather/blob/master/LICENSE"
  },
  {
    "id": "lu",
    "name": "Lucide",
    "projectUrl": "https://lucide.dev/",
    "license": "ISC",
    "licenseUrl": "https://github.com/lucide-icons/lucide/blob/main/LICENSE"
  },
  {
    "id": "gi",
    "name": "Game Icons",
    "projectUrl": "https://game-icons.net/",
    "license": "CC BY 3.0",
    "licenseUrl": "https://creativecommons.org/licenses/by/3.0/"
  },
  {
    "id": "wi",
    "name": "Weather Icons",
    "projectUrl": "https://erikflowers.github.io/weather-icons/",
    "license": "SIL OFL 1.1",
    "licenseUrl": "http://scripts.sil.org/OFL"
  },
  {
    "id": "di",
    "name": "Devicons",
    "projectUrl": "https://vorillaz.github.io/devicons/",
    "license": "MIT",
    "licenseUrl": "https://opensource.org/licenses/MIT"
  },
  {
    "id": "ai",
    "name": "Ant Design Icons",
    "projectUrl": "https://github.com/ant-design/ant-design-icons",
    "license": "MIT",
    "licenseUrl": "https://opensource.org/licenses/MIT"
  },
  {
    "id": "bs",
    "name": "Bootstrap Icons",
    "projectUrl": "https://github.com/twbs/icons",
    "license": "MIT",
    "licenseUrl": "https://opensource.org/licenses/MIT"
  },
  {
    "id": "ri",
    "name": "Remix Icon",
    "projectUrl": "https://github.com/Remix-Design/RemixIcon",
    "license": "Apache License Version 2.0",
    "licenseUrl": "http://www.apache.org/licenses/"
  },
  {
    "id": "fc",
    "name": "Flat Color Icons",
    "projectUrl": "https://github.com/icons8/flat-color-icons",
    "license": "MIT",
    "licenseUrl": "https://opensource.org/licenses/MIT"
  },
  {
    "id": "gr",
    "name": "Grommet-Icons",
    "projectUrl": "https://github.com/grommet/grommet-icons",
    "license": "Apache License Version 2.0",
    "licenseUrl": "http://www.apache.org/licenses/"
  },
  {
    "id": "hi",
    "name": "Heroicons",
    "projectUrl": "https://github.com/tailwindlabs/heroicons",
    "license": "MIT",
    "licenseUrl": "https://opensource.org/licenses/MIT"
  },
  {
    "id": "hi2",
    "name": "Heroicons 2",
    "projectUrl": "https://github.com/tailwindlabs/heroicons",
    "license": "MIT",
    "licenseUrl": "https://opensource.org/licenses/MIT"
  },
  {
    "id": "si",
    "name": "Simple Icons",
    "projectUrl": "https://simpleicons.org/",
    "license": "CC0 1.0 Universal",
    "licenseUrl": "https://creativecommons.org/publicdomain/zero/1.0/"
  },
  {
    "id": "sl",
    "name": "Simple Line Icons",
    "projectUrl": "https://thesabbir.github.io/simple-line-icons/",
    "license": "MIT",
    "licenseUrl": "https://opensource.org/licenses/MIT"
  },
  {
    "id": "im",
    "name": "IcoMoon Free",
    "projectUrl": "https://github.com/Keyamoon/IcoMoon-Free",
    "license": "CC BY 4.0 License",
    "licenseUrl": "https://github.com/Keyamoon/IcoMoon-Free/blob/master/License.txt"
  },
  {
    "id": "bi",
    "name": "BoxIcons",
    "projectUrl": "https://github.com/atisawd/boxicons",
    "license": "CC BY 4.0 License",
    "licenseUrl": "https://github.com/atisawd/boxicons/blob/master/LICENSE"
  },
  {
    "id": "cg",
    "name": "css.gg",
    "projectUrl": "https://github.com/astrit/css.gg",
    "license": "MIT",
    "licenseUrl": "https://opensource.org/licenses/MIT"
  },
  {
    "id": "vsc",
    "name": "VS Code Icons",
    "projectUrl": "https://github.com/microsoft/vscode-codicons",
    "license": "CC BY 4.0",
    "licenseUrl": "https://creativecommons.org/licenses/by/4.0/"
  },
  {
    "id": "tb",
    "name": "Tabler Icons",
    "projectUrl": "https://github.com/tabler/tabler-icons",
    "license": "MIT",
    "licenseUrl": "https://opensource.org/licenses/MIT"
  },
  {
    "id": "tfi",
    "name": "Themify Icons",
    "projectUrl": "https://github.com/lykmapipo/themify-icons",
    "license": "MIT",
    "licenseUrl": "https://github.com/thecreation/standard-icons/blob/master/modules/themify-icons/LICENSE"
  },
  {
    "id": "rx",
    "name": "Radix Icons",
    "projectUrl": "https://icons.radix-ui.com",
    "license": "MIT",
    "licenseUrl": "https://github.com/radix-ui/icons/blob/master/LICENSE"
  },
  {
    "id": "pi",
    "name": "Phosphor Icons",
    "projectUrl": "https://github.com/phosphor-icons/core",
    "license": "MIT",
    "licenseUrl": "https://github.com/phosphor-icons/core/blob/main/LICENSE"
  },
  {
    "id": "lia",
    "name": "Icons8 Line Awesome",
    "projectUrl": "https://icons8.com/line-awesome",
    "license": "MIT",
    "licenseUrl": "https://github.com/icons8/line-awesome/blob/master/LICENSE.md"
  }
]
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./node_modules/react-icons/lib/esm/iconContext.js

var DefaultContext = {
  color: undefined,
  size: undefined,
  className: undefined,
  style: undefined,
  attr: undefined
};
var IconContext = react.createContext && react.createContext(DefaultContext);
;// CONCATENATED MODULE: ./node_modules/react-icons/lib/esm/iconBase.js
var __assign = undefined && undefined.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __rest = undefined && undefined.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};


function Tree2Element(tree) {
  return tree && tree.map(function (node, i) {
    return react.createElement(node.tag, __assign({
      key: i
    }, node.attr), Tree2Element(node.child));
  });
}
function GenIcon(data) {
  // eslint-disable-next-line react/display-name
  return function (props) {
    return react.createElement(IconBase, __assign({
      attr: __assign({}, data.attr)
    }, props), Tree2Element(data.child));
  };
}
function IconBase(props) {
  var elem = function (conf) {
    var attr = props.attr,
      size = props.size,
      title = props.title,
      svgProps = __rest(props, ["attr", "size", "title"]);
    var computedSize = size || conf.size || "1em";
    var className;
    if (conf.className) className = conf.className;
    if (props.className) className = (className ? className + " " : "") + props.className;
    return react.createElement("svg", __assign({
      stroke: "currentColor",
      fill: "currentColor",
      strokeWidth: "0"
    }, conf.attr, attr, svgProps, {
      className: className,
      style: __assign(__assign({
        color: props.color || conf.color
      }, conf.style), props.style),
      height: computedSize,
      width: computedSize,
      xmlns: "http://www.w3.org/2000/svg"
    }), title && react.createElement("title", null, title), props.children);
  };
  return IconContext !== undefined ? react.createElement(IconContext.Consumer, null, function (conf) {
    return elem(conf);
  }) : elem(DefaultContext);
}
;// CONCATENATED MODULE: ./node_modules/react-icons/lib/esm/index.js




/***/ })

}]);